import { getCountFromServer } from "firebase/firestore";
import { Repository } from "src/firebase/firestore/repository";
import { buildFilterQuery } from "src/firebase/firestore/filterQueryBuilderV3";
import { RewardExchange } from "../types/karma-exchange.entity";

export class KarmaExchangesRepository extends Repository<RewardExchange> {
  constructor() {
    super("reward_exchanges");
  }

  async count(where?: any): Promise<number> {
    const filterQuery = await buildFilterQuery({
      collection: this.collection,
      where,
    });
    const countResult = await getCountFromServer(filterQuery);
    return countResult.data().count;
  }
}
export const karmaExchangesRepository = new KarmaExchangesRepository();
